import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton } from '@/components';
import { CryptoIcon, Heading, useTableProps, Flex } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import IlkCdpsTable from './CdpsTable';
import TextSeatchFilter from '@/components/TextSearchFilter/TextSearchFilter';
import CdpsChart from './CdpsChart';

export default function VaultsPage() {
  const { ilk } = useParams();
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-debt',
    filtersDebounceTime: 250,
    initialFilters: {
      textSearch: ''
    }
  });

  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/`
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={<CryptoIcon name={data.collateral_symbol} size="5" />}>
            <Heading size="1">{data.ilk} CDPs</Heading>
          </EntityName>
        }>
        <CdpsChart ilk={ilk} />
        <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
          <TextSeatchFilter
            filters={filters}
            placeholder="Search by CDP or URN"
          />
        </Flex>
        <IlkCdpsTable
          ilk={ilk}
          pagination={pagination}
          sorting={sorting}
          search={filters.filtersApplied['textSearch']}
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
